import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _actionMappings;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ActionName } from '../../../../constants';
import { FlexibleUiContext } from '../../../../state/flexible-ui-context';
import React, { useContext } from 'react';
import Action from './action';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../../messages';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import EditIcon from '@atlaskit/icon/glyph/edit';
import PreviewAction from './action/preview-action';
import VidFullScreenOnIcon from '@atlaskit/icon/glyph/vid-full-screen-on';
import ViewAction from './action/view-action';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import DownloadAction from './action/download-action';
import DownloadIcon from '@atlaskit/icon/glyph/download';
var actionMappings = (_actionMappings = {}, _defineProperty(_actionMappings, ActionName.CustomAction, {
  component: Action,
  props: {}
}), _defineProperty(_actionMappings, ActionName.DeleteAction, {
  component: Action,
  props: {
    testId: 'smart-action-delete-action',
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete),
    icon: /*#__PURE__*/React.createElement(CrossIcon, {
      label: "Delete"
    }),
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete)
  }
}), _defineProperty(_actionMappings, ActionName.EditAction, {
  component: Action,
  props: {
    testId: 'smart-action-edit-action',
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit),
    icon: /*#__PURE__*/React.createElement(EditIcon, {
      label: "Edit"
    }),
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit)
  }
}), _defineProperty(_actionMappings, ActionName.PreviewAction, {
  component: PreviewAction,
  props: {
    testId: 'smart-action-preview-action',
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_improved),
    icon: /*#__PURE__*/React.createElement(VidFullScreenOnIcon, {
      label: "Open preview"
    }),
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_improved)
  }
}), _defineProperty(_actionMappings, ActionName.ViewAction, {
  component: ViewAction,
  props: {
    testId: 'smart-action-view-action',
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.view),
    icon: /*#__PURE__*/React.createElement(ShortcutIcon, {
      label: "View"
    }),
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.view)
  }
}), _defineProperty(_actionMappings, ActionName.DownloadAction, {
  component: DownloadAction,
  props: {
    testId: 'smart-action-download-action',
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.download),
    icon: /*#__PURE__*/React.createElement(DownloadIcon, {
      label: "Download"
    }),
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.download)
  }
}), _actionMappings);
var getContextKey = function getContextKey(name) {
  // Attempt to predict context prop name in advance to reduce the amount of
  // code run during runtime
  return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
var getActionData = function getActionData(actionName, contextKey, context) {
  if (!context) {
    return undefined;
  }
  var data = context[contextKey];
  switch (actionName) {
    case ActionName.PreviewAction:
    case ActionName.ViewAction:
    case ActionName.DownloadAction:
      return data;
    default:
      return undefined;
  }
};
export var createDataAction = function createDataAction(name) {
  var _ref = actionMappings[name] || {},
    BaseAction = _ref.component,
    props = _ref.props;
  var contextKey = getContextKey(name);
  if (!BaseAction) {
    throw Error("Action ".concat(name, " does not exist."));
  }
  return function (overrides) {
    var context = useContext(FlexibleUiContext);
    var data = getActionData(name, contextKey, context);
    return data && _typeof(data) === 'object' ? /*#__PURE__*/React.createElement(BaseAction, _extends({}, props, data, overrides, {
      url: context === null || context === void 0 ? void 0 : context.url
    })) : null;
  };
};
export var createUIAction = function createUIAction(name) {
  var _ref2 = actionMappings[name] || {},
    BaseAction = _ref2.component,
    props = _ref2.props;
  if (!BaseAction) {
    throw Error("Action ".concat(name, " does not exist."));
  }
  return function (overrides) {
    var combinedProps = _objectSpread(_objectSpread({}, props), overrides);
    return /*#__PURE__*/React.createElement(BaseAction, combinedProps);
  };
};